import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';
import {DocumentType} from '../model/Entities/DocumentType';
import {DocumentCompany} from '../model/Entities/DocumentCompany';

@Injectable()
export class DocumentCompanyService extends ApiService<DocumentCompany> {

    protected apiUrl = 'api/document-company';  // URL to web api

    protected getObjectType(): any {
        return DocumentCompany;
    }
}



// WEBPACK FOOTER //
// /app/src/services/document-company.service.ts